import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { enrollmentLinksApi } from '../services/enrollmentLinksApi'
import { getTenantId } from '../config/tenant'

export const useEnrollmentLinks = () => {
  const tenantId = getTenantId()
  return useQuery({
    queryKey: ['enrollment-links', tenantId],
    queryFn: () => {
      if (!tenantId) throw new Error('tenantId não encontrado')
      return enrollmentLinksApi.getByTenant(tenantId)
    },
    enabled: !!tenantId,
  })
}

export const useEnrollmentLinksByGroup = (groupId, enabled = true) => {
  const tenantId = getTenantId()
  return useQuery({
    queryKey: ['enrollment-links-group', tenantId, groupId ?? 'root'],
    queryFn: () => {
      if (!tenantId) throw new Error('tenantId não encontrado')
      return enrollmentLinksApi.getByGroup(tenantId, groupId)
    },
    enabled: !!tenantId && enabled,
  })
}

export const useCreateEnrollmentLink = () => {
  const qc = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (data) => enrollmentLinksApi.create(tenantId, data),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ['enrollment-links', tenantId] })
      qc.invalidateQueries({ queryKey: ['enrollment-links-group', tenantId, variables.groupId ?? 'root'] })
    },
  })
}

export const useUpdateEnrollmentLink = () => {
  const qc = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: ({ id, ...data }) => enrollmentLinksApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['enrollment-links', tenantId] })
      qc.invalidateQueries({ queryKey: ['enrollment-links-group', tenantId] })
    },
  })
}

export const useCancelEnrollmentLink = () => {
  const qc = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (id) => enrollmentLinksApi.cancel(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['enrollment-links', tenantId] })
      qc.invalidateQueries({ queryKey: ['enrollment-links-group', tenantId] })
    },
  })
}

export const useDeleteEnrollmentLink = () => {
  const qc = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: (id) => enrollmentLinksApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['enrollment-links', tenantId] })
      qc.invalidateQueries({ queryKey: ['enrollment-links-group', tenantId] })
    },
  })
}

export const useApproveAgent = () => {
  const qc = useQueryClient()
  const tenantId = getTenantId()
  return useMutation({
    mutationFn: ({ agentId, ...data }) => enrollmentLinksApi.approve(agentId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['hosts', tenantId] }),
  })
}
